import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

type ConfirmVariant = 'danger' | 'warning' | 'primary';

@Component({
  selector: 'app-confirm-modal',
  imports: [CommonModule],
  templateUrl: './confirm-modal.html',
  styleUrl: './confirm-modal.css',
})
export class ConfirmModal implements OnChanges {
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Input() title = '¡Acción requerida!';
  @Input() subtitle = '¿Estás seguro de eliminar este registro?';
  @Input() cancelText = 'No, cancelar';
  @Input() confirmText = 'Sí, eliminar';

  @Input() variant: ConfirmVariant = 'danger';
  @Input() closeOnBackdrop = true;
  @Input() loading = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  @ViewChild('confirmBtn') confirmBtn?: ElementRef<HTMLButtonElement>;

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['open']?.currentValue && !ch['open'].previousValue) {
      setTimeout(() => this.confirmBtn?.nativeElement.focus(), 0);
    }
  }

  @HostListener('document:keydown', ['$event'])
  onDocKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      this.onCancel();
    }
  }

  onBackdropClick() {
    if (!this.closeOnBackdrop || this.loading) return;
    this.onCancel();
  }

  onCancel() {
    this.cancel.emit();
    this.open = false;
    this.openChange.emit(false);
  }

  onConfirm() {
    if (this.loading) return;
    this.confirm.emit();
    this.open = false;
    this.openChange.emit(false);
  }

  get confirmBtnClasses() {
    const base =
      'shadow-theme-xs flex justify-center rounded-lg px-4 py-3 text-sm font-medium text-white disabled:opacity-60';
    const map: Record<ConfirmVariant, string> = {
      danger: 'bg-red-500 hover:bg-red-600',
      warning: 'bg-amber-500 hover:bg-amber-600',
      primary: 'bg-brand-600 hover:bg-brand-700',
    };
    return `${base} ${map[this.variant]}`;
  }
}
